module.exports = __webpack_public_path__ + "static/media/cuckooclock.06d684bc.mp3";